import { render } from "./NotFoundLayout.vue?vue&type=template&id=8ac6621c&scoped=true"
import script from "./NotFoundLayout.vue?vue&type=script&lang=js"
export * from "./NotFoundLayout.vue?vue&type=script&lang=js"

import "./NotFoundLayout.vue?vue&type=style&index=0&id=8ac6621c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8ac6621c"

export default script